import Cookies, { CookieGetOptions } from "universal-cookie";

const C = new Cookies()

export default function useCookie(name: string, options?: CookieGetOptions): any {
    return C.get(name, options)
}